<form [formGroup]="registerForm" (ngSubmit)="onSignup()">
  <h2 class="mb-1">
    <strong>Sign-up</strong>
  </h2>
  <div>
    <p>
      Please provide your details to access your ATAR once released.
    </p>
  </div>
  <div
    class="mb-1 qtac-error-container"
    data-test="error-message-register-main"
    *ngIf="showRegistrationInvalid"
  >
    {{ registrationErrorMessage }}
  </div>
  <div class="mb-1">
    <div>Email Address *</div>
    <input
      class="qtac-input"
      data-test="register-input-email"
      name="email"
      formControlName="email"
      value=""
    />
    <div class="note-text">
      Note: Please use a personal email address, not your school email address.
    </div>
    <ng-container *ngFor="let error of error_messages.email">
      <small
        data-test="error-email"
        *ngIf="
          formControls.email.hasError(error.type) && formControls.email.touched
        "
        class="form-error-msg error-msg"
      >
        {{ error.message }}
      </small>
    </ng-container>
  </div>

  <div class="mb-1">
    <div>Password *</div>
    <input
      class="qtac-input"
      data-test="register-input-password"
      type="password"
      name="password"
      formControlName="password"
      value=""
    />
    <ng-container *ngFor="let error of error_messages.password">
      <small
        data-test="error-new-password"
        *ngIf="
          formControls.password.hasError(error.type) &&
          formControls.password.touched
        "
        class="form-error-msg error-msg"
      >
        {{ error.message }}
      </small>
    </ng-container>
  </div>

  <div class="mb-1">
    <div>Confirm Password *</div>
    <input
      data-test="register-input-confirm-password"
      class="qtac-input"
      name="confirm-password"
      type="password"
      required
      formControlName="confirmPassword"
      value=""
    />
    <ng-container *ngFor="let error of error_messages.confirmPassword">
      <small
        data-test="error-confirm-password"
        *ngIf="
          formControls.confirmPassword.hasError(error.type) &&
          formControls.confirmPassword.touched
        "
        class="form-error-msg error-msg"
      >
        {{ error.message }}
      </small>
    </ng-container>
  </div>

  <button
    mat-raised-button
    class="full-width mb-1"
    data-test="submit-button-register"
    [disabled]="registerForm.invalid"
  >
    SIGN UP
  </button>
</form>
